import { TFunction } from 'i18next';
import { TGroupSchema } from '@/schemas/group/group.schema';
import { SubscribedGroupCard } from '../SubscribedGroupCard';
import { getFormattedDate } from '@/utils/date.utils';

interface SubscribedGroupListProps {
  t: TFunction<undefined>;
  data: TGroupSchema[];
}

export const SubscribedGroupList = ({ t, data }: SubscribedGroupListProps) => {
  return (
    <div className="flex flex-col gap-4">
      {data?.map((item) => (
        <SubscribedGroupCard
          t={t}
          key={item?.id}
          linkTo={`/group/edit/${item?.id}`}
          avatarUrl={item?.logo}
          groupName={item?.name}
          registrationEndDate={getFormattedDate(
            item?.groupSubscription?.endDate || ''
          )}
        />
      ))}
    </div>
  );
};
